import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesSalesOrderProperty } from './entities/selectors/sales-orders';
import { MarketplaceIds } from '../enums/marketplace-ids';

export const useIsManualOrder = (salesOrderId) => {
  const { marketplaceId } = useEntitiesSalesOrderProperty(salesOrderId, 'store') || emptyObject;
  return marketplaceId === `${MarketplaceIds.ShipStation}`;
};
